<template>
    <div class="loan_form">
   
        <b-overlay :show="showoverlaymodal" rounded="sm">
              {{checkPFLimit}}
              <b-form @submit.stop.prevent="onSubmit">
                <!-- <div class="clearfix border rounded mb-3 mr-3 mb-0 col-md-12">
                    <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">Current Provident Fund Balance : {{formatMoney(pf_contribution)}}</div></div>
                </div> -->

                <div class="clearfix border rounded mb-3 mr-3 mb-0 col-md-12">
                    <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">Total Provident Fund Balance : {{formatMoney(total_pf_balance)}}</div></div>
                </div>
                <div class="clearfix border rounded mb-3 mr-3 mb-0 col-md-12">
                    <div class="row justify-content-center"><div class="col-sm-12 mt-1 mb-1 text-center">Existing Loan Balance : {{formatMoney(existing_loan_balance)}}</div></div>
                </div>
                <b-form-group id="loan_amount-group" v-bind:label="amount_title" label-for="loan_amount">
                    <b-form-input id="loan_amount"  name="loan_amount" :disabled="disableamount" v-model="fdata.loan_amount" v-validate="{ required: true }" :state="validateState('loan_amount')" aria-describedby="loan_amount-feedback" data-vv-as="Loan/Advance Amount"></b-form-input>
                    <b-form-invalid-feedback id="loan_amount-feedback">{{ veeErrors.first('loan_amount') }}</b-form-invalid-feedback>
                    <div class="invalid-feedback" style="display:block !important;" v-if="this.pf_loan_form_disable==true">The Loan Amount must be less or equal to the total provident fund balance</div>
                    <div style="min-height:30px;">
                        <div v-show="disable_submit_amount==true" class="mb-1"  style="font-size: 80% !important; color: #e3342f !important" id="submit-disable">Loan amount is invalid</div>
                    </div>
                </b-form-group>

                <b-form-group id="paid_amount-group" v-bind:label="paid_amount_title" label-for="paid_amount" v-show="edit_form==1 && disableamount == true">
                    <b-form-input id="paid_amount"  name="paid_amount" :disabled="disableme" v-model="fdata.paid_amount" ></b-form-input>
                </b-form-group>

                <b-form-group id="remaining_amount-group" v-bind:label="remaining_amount_title" label-for="remaining_amount" v-show="edit_form==1 && disableamount == true">
                    <b-form-input id="remaining_amount"  name="remaining_amount" :disabled="disableme" v-model="fdata.remaining_amount" ></b-form-input>
                </b-form-group>

                <b-form-group id="effective_date_of_loan-group" v-bind:label="effective_date_title" label-for="effective_date_of_loan">
                    <b-input-group class="mb-3">
                        <b-input-group-append>
                            <b-form-input id="effective_date_of_loan_text"  :disabled="disableme" name="effective_date_of_loan_text" v-model="fdata.effective_date_of_loan" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('effective_date_of_loan_text')" aria-describedby="effective_date_of_loan_text-feedback" data-vv-as="Effective Date of Loan/Salary Advance"></b-form-input>
                            <b-form-datepicker id="day_one" @input="getAvailableMonths(fdata.effective_date_of_loan)" button-only right locale="en-US" :min="date_min" :disabled="disableme"   v-model="fdata.effective_date_of_loan"></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback id="effective_date_of_loan_text-feedback">{{ veeErrors.first('effective_date_of_loan_text') }}</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
                <!-- <b-form-group id="change-next-deduction-month-group" v-show="edit_form==1" >
                <b-form-checkbox id="checkbox-1" v-model="change_deduction_trigger" name="change_deduction" value=1 unchecked-value=0 >
                Change Next Deduction Month
                </b-form-checkbox>
                </b-form-group>
                <b-form-group id="change-remaining-tenure-group" v-show="edit_form==1">
                <b-form-checkbox id="checkbox-2" v-model="change_tenure_trigger"  name="change_tenure" value=1 unchecked-value=0  v-show="edit_form==1">
                Change Remaining Tenure
                </b-form-checkbox>
                </b-form-group> -->
                <b-form-group id="deduction_start_month-group" v-bind:label="deduction_start_month_title" label-for="deduction_start_month">
                    <b-form-select id="deduction_start_month"   name="deduction_start_month" v-model="fdata.deduction_start_month" :options="m_lists" v-validate="{ required: true }" :state="validateState('deduction_start_month')" aria-describedby="deduction_start_month-feedback" data-vv-as="Loan/Advance Deduction Start Month"></b-form-select>
                    <b-form-invalid-feedback id="deduction_start_month-feedback">{{ veeErrors.first('deduction_start_month') }}</b-form-invalid-feedback>
                </b-form-group>

              

                <b-form-group id="loan_tenure-group" v-bind:label="tenure_title" label-for="loan_tenure">
                    <b-form-input class = "d-inline-block mr-2 align-middle"   style = "width :75%" id="range-1" v-model="fdata.loan_tenure" type="range" min="1" :max="300" v-validate="{ required: true }" :state="validateState('loan_tenure')" aria-describedby="loan_tenure-feedback" data-vv-as="Loan/Advance repayment tenure"></b-form-input>
                    <div class="d-inline-block p-1 border align-middle"> {{ fdata.loan_tenure }} Month(s)</div>
                    <b-form-invalid-feedback id="loan_tenure-feedback">{{ veeErrors.first('loan_tenure') }}</b-form-invalid-feedback> 
                </b-form-group>
            
                    
                <a href="javascript:void(0);" v-show="showInstallment==true"  class="btn mb-2 btn-primary btn-full-width"   @click="showInstallments()" >Show Proposed Installments</a>
                <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInstallmentamount" name="ins"></b-form-input>
                <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="onInstallmentChange" name="onInstallmentChange"></b-form-input>
                <b-form-input  class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:48%;display:none !important;' v-model="checkInput" name="onInstallmentChange"></b-form-input>
            
                <div class="mt-1" v-show="show_installment_click==true"> 
                    <div style="min-height:30px;">
                        <div v-show="disable_submit==true && loan_installments.length>0 " class="invalid-feedback" style="display:block !important;"  id="submit-disable">{{remaining_installment_amount}}</div>
                    </div>
                    
                    <div class="" v-for="(row, index) in loan_installments" :key="index">                                 
                        <div class="form-group">
                            <b-form-group id="loan_installments">
                                <div class = "d-inline-block mr-2 align-middle" disabled style = 'width:32%; padding: 6px 6px !important;background: #e9ecef;border-radius: 5px;border: 1px solid #ced4da; color: #495057;' >Installment #{{index+1}}</div>
                                <b-form-input class = "d-inline-block p-1 mr-2 align-middle" disabled style = 'width:32%;' v-model="loan_installments[index].month"></b-form-input>
                                <b-form-input class = "d-inline-block p-1  align-middle" disabled style = 'width:32%;' :name="'installment_'+index" v-model="loan_installments[index].amount" v-validate="{ required: true }" :state="validateState('installment_'+index)" :aria-describedby="'installment_'+index" data-vv-as="Custom Payment Amount"></b-form-input>
                                <b-form-invalid-feedback :id="'installment_'+index">{{ veeErrors.first('installment_'+index) }}</b-form-invalid-feedback>  
                            </b-form-group>  
                        </div>                                 
                    </div> 
                </div>

                <b-form-group id="details-group" v-bind:label="details_title" label-for="loan_details" v-show="is_custom_payment != 1" >
                    <b-form-textarea id="loan_details" placeholder="Enter something..." rows="3" max-rows="6"  v-model="fdata.details"  v-validate="{ required: false }" :state="validateState('loan_details')" aria-describedby="loan_details-feedback" data-vv-as="Loan/Advance Details"></b-form-textarea>
                    <b-form-invalid-feedback id="loan_details-feedback">{{ veeErrors.first('loan_details') }}</b-form-invalid-feedback>
                </b-form-group>
                
                <b-button class = "mt-1" type="submit" :disabled="disable_submit_all" variant="primary">Submit</b-button>
            </b-form>
        
        </b-overlay>               

    </div>

</template>
<script>

    var moment = require('moment');
    const numFormatter = new Intl.NumberFormat('en-US', {
    style: "decimal",
    maximumFractionDigits: 2
    })
    export default{
        
        mounted() {
             
        },
        props: ['pageurl','bn','flg','employee_id','employee_name','count','loan_id','is_custom','is_status'],
        data(){   
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);

            return {
                date_min:minDate,
                successmsg:'',
                deduction_start : true,
                edit_change_click : false,
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                loan_stat_div: ["text-danger","text-info","text-success","text-muted","text-purple"],
                default_tenure: [0,12,1],
                showoverlay_list : false,       
                disableme: false,    
                disableamount:false,
                disable_submit :false,       
                disable_submit_new :false,    
                disable_submit_all :false,     
                disable_submit_amount:false,
                successmsg:'',
                errormsg:[],
                remaining_amount_money : 0,
                loan_installments:[],
                selected_bank_id:0,
                loading:'',
                is_custom_payment :0,
                loan_title:'',
                company_title:'',
                remaining_installment_amount:0,
                modal_title: '',
                employee_front:false,
                company_id_title : '',
                amount_title: '',
                deduction_start_month_title:'',
                effective_date_title :'',
                status_title : '',
                showoverlaymodal : false,
                change_tenure : true,
                change_deduction : true,
                change_tenure_trigger : 0,
                change_deduction_trigger : 0,
                showInstallment:false,
                show_installment_click :false,
                details_title: '',
                tenure_title:'',
                loan_entity_id:'',
                loan_update_status:'',
                loan_type: 1,
                loan_type_title: 'Process Type',
                loan_type_select: 1,
                edit_form : 0,
                loan_tenure_new:0,
                custom_amount : 0,
                custom_tenure_limit:0, 
                tenure_length_edit :'',
                custom_payment_title :'Custom Payment Amount',
                paid_amount_title: 'Paid Amount',
                remaining_amount_title:'Remaining Amount',
                loan_types_drop : ['','Loan','Advance'],
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Decline" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approve" },
                    { value: "3", text: "Pause/Stop" },
                ],
                loan_type_vals:[
                    { value: "1", text: "Loan" },
                    { value: "2", text: "Advance" },

                ],
                fdata : {company_loan_id:'', employee_id:'',installments:[], loan_amount:'',loan_type:'',effective_date_of_loan:null ,deduction_start_month:null , core_hr:'' , loan_tenure:'',details:'',status:2,next_installment_month:'',paid_amount:'',change_deduction:"No",change_tenure:"No",paid_tenure:0,remaining_tenure:0,remaining_amount:'',custom_amount:0,core_hr:null},
                m_lists : [],
                m_list_2 : [],
                installment2 : [],
                no_installment : true,
                pf_contribution :0,
                pf_loan_form_disable:false,
                last_payrun_month:'',
                total_pf_balance:0,
                existing_loan_balance:0,
            }
        },
        methods:{

            
            showInstallments()
            {
                this.show_installment_click = true;
            },
            editLoanInfo:function(x,type)
            {        
                this.showoverlaymodal = true;
                if(!this.checkNet()) return false;

                    if(type==0)
                    {
                        this.resetForm();
                        this.is_custom_payment =0;
                    }
                    if(type==1)
                    {
                        this.resetForm();
                        this.is_custom_payment =1;
                    }
                    axios.get(this.$api_url+'/pf/loan/edit' , {
                        params: {
                            id: x 
                        }
                    })
                    .then(function(response){
                        this.edit_change_click = false;
                        this.fdata = response.data;
  
                        
                        /***** */
                        if(this.fdata.loan_amount != this.fdata.remaining_amount)
                        {
                            this.loan_status = [{ value: null, text: "Select..." },{ value: "2", text: "Approve" },{ value: "3", text: "Pause/Stop" }];
                        }

                        this.disableamount = true;
                        if(this.fdata.status==1)
                        {
                           this.loan_status =  [{ value: null, text: "Select..." },{ value: "0", text: "Decline" },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
                           this.disableamount = false;
                        
                        }

                        this.fdata.loan_amount =  this.formatMoney(this.fdata.loan_amount);
                        this.fdata.paid_amount =  this.formatMoney(this.fdata.paid_amount);
                        this.remaining_amount_money  = this.fdata.remaining_amount;
                        this.fdata.remaining_amount =  this.formatMoney(this.fdata.remaining_amount);

                        /***** */
                        this.fdata.custom_amount = 0;
                        this.custom_amount = 0;
                        this.loan_installments = this.fdata.installments; 

                        if(this.loan_installments.length>0) 
                        {
                            for(let i = 0; i<this.loan_installments.length; i++)
                            {
                                this.loan_installments[i].amount = this.formatMoney(this.loan_installments[i].amount);
                            }

                        }
                        this.loan_type = this.fdata.loan_type;  
                        // this.custom_tenure_limit = this.fdata.remaining_tenure
                        this.custom_tenure_limit = 300;
                        this.edit_form = 1;
                        this.setFormtitle(this.loan_type);
                        this.successmsg = null;
                        this.disableme = true;
                        if(this.fdata.paid_amount ==0)
                        {
                            this.disableme = false;
                            
                        }
                        
                        this.disable_submit =false;
                        this.disable_submit_all =false;
                        this.disable_submit_new =false;
                        this.disable_submit_amount =false;
                        

                        this.change_tenure_trigger = 0,
                        this.change_deduction_trigger = 0,
                        this.pf_loan_form_disable=false;
                        this.pf_contribution = 0,
                        this.employee_id = this.fdata.employee_id;
                        this.getLastPayrun(this.employee_id);
                        this.getAvailablePf();
                        this.getInstallments();
                        this.getAvailableMonths(this.fdata.effective_date_of_loan);

                        
                        this.getNextAvailableMonths();
                        this.loan_tenure_new = this.fdata.remaining_tenure;
                        this.deduction_start_month_title = 'Loan Deduction Start Month'; 
                        this.tenure_title = 'Remaining Repayment Tenure'; 

                        var paid_amount = this.toMoney(this.fdata.paid_amount);

                        if(paid_amount>0 || this.is_custom_payment==1)
                        {
                            this.no_installment = false;
                            this.disableamount = true;
                        }

                        if(this.is_status != 0)
                        {
                            this.fdata.status = this.is_status;
                        }

                        this.showoverlaymodal = false;

                    }.bind(this)).catch(function (error){alert(error)});

                
                
            },   
            resetForm()
            {     
                this.pf_contribution = 0;
                this.no_installment = true;
                this.edit_change_click = false;
                this.show_installment_click = false;
                this.deduction_start = true;
                this.disable_submit =false;
                this.disable_submit_all =false;
                this.disable_submit_amount =false;
                this.disable_submit_new =false;
                this.showInstallment = false; 
                this.disableme = false;
                this.disableamount = false,
                this.loan_tenure_new =0;
                this.loan_installments = [];
                this.edit_form =0;
                this.custom_amount =0; 
                this.is_custom_payment = 0;
                this.tenure_length_edit =1;
                this.change_tenure_trigger = 1,
                this.change_deduction_trigger = 1,
                this.setFormtitle(this.loan_type);
                
                this.fdata = {company_loan_id:'', employee_id:this.employee_id, loan_amount:'',installments:[],remaining_amount: null,next_installment_month:'',loan_type:this.loan_type, effective_date_of_loan:'' , deduction_start_month:null , loan_tenure:this.default_tenure[this.loan_type],details:'',status:1,paid_amount:'',paid_tenure:0,remaining_tenure:0,remaining_amount:'',change_deduction:"No",change_tenure:"No",custom_amount:0,core_hr:"1"};
                if(this.is_front==1)
                {
                    this.fdata.status = 1;
                } 
                this.$nextTick(() => {
                    this.$validator.reset();
                }); 

            },  
            changeDateAndTenure()
            {
                this.edit_change_click = true;
            },
            getAvailableMonths(date)
            {
                if(!this.edit_form)
                {
                    var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];

                    /** Get Last Payrun Date **/
                    var last_payrun_month_2 = this.last_payrun_month;
                    const str_month_arr_2 = last_payrun_month_2.split("-");
                    var payrun_year   = parseInt(str_month_arr_2[1]);
                    var p_month  = str_month_arr_2[0]; 
                    var payrun_month = m_names.indexOf(p_month);
                    var dt1   = 1;
                    const payrun_date = new Date(payrun_year,payrun_month,dt1);
                    payrun_date.setMonth(payrun_date.getMonth()+1);
                    /****/
                    //this.fdata.deduction_start_month = null;
                    var yr1   = parseInt(date.substring(0,4));
                    var mon1  = parseInt(date.substring(5,8)); 
                    var dt1   = parseInt(date.substring(8,10));
                    var all_months = [];
                    
                    all_months.push({value: null,text: "Select..."}); 
                    let mt =0;
                    console.log(payrun_date);
                    for (let i = 1; i <= 24;) 
                    { 
                        var d = new Date(yr1, mon1-1, dt1);
                        if(d.getDate()>27)
                        {
                            d.setDate(d.getDate() - 5);
                        }
                        d.setMonth(d.getMonth() + mt);


                        if(d.getTime() >= payrun_date.getTime())
                        {
                            var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                            all_months.push({value: fullText,text:fullText});
                            i++;
                        
                        }
                        
                        mt++;
                  
                    }
                    
                    if(all_months.length>=24)
                    {
                        this.m_lists =  all_months;
                        this.deduction_start = false;
                    }
                }
                else
                {

                    axios.get(this.$api_url+'/pf/get-last-payrun', {
                    params: {
                    employee_id:this.employee_id,
                    effective_date:date
                    }
                    }).then(function(response)
                    { 

                        var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];
                        /** Get Last Payrun Date **/
                        this.last_payrun_month = response.data;
                        var last_payrun_month_2 = this.last_payrun_month;
                        const str_month_arr_2 = last_payrun_month_2.split("-");
                        var payrun_year   = parseInt(str_month_arr_2[1]);
                        var p_month  = str_month_arr_2[0]; 
                        var payrun_month = m_names.indexOf(p_month);
                        var dt1   = 1;
                        var payrun_date = new Date(payrun_year,payrun_month,dt1);
                        payrun_date.setMonth(payrun_date.getMonth()+1);

                        
                        this.date_min = payrun_date;

                        console.log(this.date_min);


                        var yr1   = parseInt(date.substring(0,4));
                        var mon1  = parseInt(date.substring(5,8)); 
                        var dt1   = parseInt(date.substring(8,10));
                        var all_months = [];
                        var not_avail = 1;
                        var first_full = '';


                        var selected_date = new Date(yr1, mon1-1, dt1);

                        var date_check = Date.parse(payrun_date) > Date.parse(selected_date);

                        
                        if(date_check)
                        {
                            this.fdata.effective_date_of_loan = '';
                            this.fdata.deduction_start_month = '';
                            
                        }


                        all_months.push({value: null,text: "Select..."}); 
                        let mt =0;
                        for (let i = 1; i <= 24;) 
                        { 
                            var d = new Date(yr1, mon1-1, dt1);
                            if(d.getDate()>27)
                            {
                                d.setDate(d.getDate() - 5);
                            }
                            d.setMonth(d.getMonth() + mt);

                            if(d.getTime() >= payrun_date.getTime())
                            {
                                var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                                if(this.fdata.deduction_start_month==fullText)
                                {
                                    not_avail = 0;
                                }
                                if(i==1)
                                {
                                    first_full = fullText;
                                    //this.getInstallments();
                                } 
                                all_months.push({value: fullText,text:fullText});
                                i++;
                            
                            }
                            
                            mt++;
                        }
                        if(not_avail && date_check==false)
                        {
                            this.fdata.deduction_start_month = first_full;
                        }
                        
                        if(all_months.length>=24)
                        {
                            this.m_lists =  all_months;
                            this.deduction_start = false;
                        }




                    }.bind(this));
                }

            },  
            getNextAvailableMonths()
            {
                if(this.edit_form)
                { 


                    var m_names = ['January', 'February', 'March', 
                            'April', 'May', 'June', 'July', 
                            'August', 'September', 'October', 'November', 'December'];
                    var all_months = [];
                    var start_month = this.fdata.next_installment_month;
                    const str_month_arr = start_month.split("-");
                    var yr1   = parseInt(str_month_arr[1]);
                    var mt  = str_month_arr[0]; 
                    var mon1 = m_names.indexOf(mt);
                    var dt1   = 1;
                    var current_date = new Date();
                    var d1 = new Date(yr1, mon1);
                    var d2 = new Date(current_date.getFullYear(), current_date.getMonth());    // 02/2014
                    var date_check = Date.parse(d2) > Date.parse(d1);
                    var no_install = false;
                    
                    if(this.fdata.remaining_tenure == this.fdata.loan_tenure || paid_amount > 0)
                    {
                        no_install = true;
                        
                    } 
                    console.log(date_check);
  
                    if(date_check==true)
                    {
                        this.loan_installments = [];
                        this.fdata.installments = [];
                        for (let i = 0; i < 24;)  
                        { 
                            var d = new Date();
                            if(d.getDate()>27)
                            {
                                d.setDate(d.getDate() - 5);
                            }
                            d.setMonth(d.getMonth() + i);
                            var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                            if(i==0)
                            {
                                this.fdata.next_installment_month = fullText;
                                //this.getInstallments();
                            } 
                            all_months.push({value: fullText,text:fullText});
                            i++;
                        }
                        
                    }
                    
                    else
                    {
                        for (let i = 0; i < 24;)  
                        { 
                            var d = new Date(yr1, mon1, dt1);
                            if(d.getDate()>27)
                            {
                                d.setDate(d.getDate() - 5);
                            }
                            d.setMonth(d.getMonth() + i);
                            var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();

                            all_months.push({value: fullText,text:fullText});
                            i++;
                        }

                    }

                    
                    
                    if(all_months.length>=24)
                    {
                        this.m_list_2 =  all_months;
                    }
                }

            },
            selecetedLoanType:function()
            {
                this.loan_type = this.loan_type_select;
                this.addNewLoan(this.loan_type);
            }, 
            validateState(ref)
            {
                if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) ) 
                {

                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            setFormtitle:function(x)
            {
                
                   //alert('here');
                   
                   this.loan_title = 'PF Loan List';
                    this.company_id_title = 'PF Loan ID';
                    this.amount_title = 'Loan Amount';
                    this.deduction_start_month_title = 'Loan Deduction Start Month';
                    this.effective_date_title = 'Effective Date of Loan';
                    this.status_title = 'Loan Status';
                    this.details_title= 'Loan Details';
                    if(this.edit_form==1)
                    {
                        this.modal_title = 'Edit Loan';
                    }
                    else
                    {
                        this.modal_title = 'Process Loan';
                    } 
                    if(this.is_custom_payment)
                    {
                        this.modal_title = 'Custom Payment';
                    }
                    this.tenure_title = 'Loan repayment tenure';
                
                
            },  
            addNewLoan:function(x)
            {
                 
                 //alert("hegeegeefefef");
                 this.resetForm();
                 this.loan_status = [{ value: null, text: "Select..." },{ value: "1", text: "Applied" },{ value: "2", text: "Approve" }];
            },
            
            // Start: Rejwan: 24-04-2025 2 decimal
			// formatMoney: function(amount)
            // {
            //     var money = Number(amount);
			// 	var dec_points = 0;

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else
			// 		{
			// 			if(money.indexOf(".") < 0)
			// 			{
			// 				money = money+".00";
			// 			}
			// 			else
			// 			{
			// 				dec_points = money.length - money.indexOf('.') - 1;

			// 				if(dec_points == 1)
			// 				{
			// 					money = money+"0";
			// 				}
			// 				else if(dec_points == 0)
			// 				{
			// 					money = money+"00";
			// 				}
			// 			}

            //     	}
			// 	}
                
            //     return money;
            // }, 
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
            getInstallments()
            {
                console.log('GETIntall');
                var m_names = ['January', 'February', 'March', 
                        'April', 'May', 'June', 'July', 
                        'August', 'September', 'October', 'November', 'December'];
                var all_months = [];
                var all_amounts = [];
                var installments = [];
                var generate = 0;
                
                var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                //if(pattern.test(this.fdata.loan_amount))
                if(1)
                {
                    var loan_tenure = parseInt(this.fdata.loan_tenure);
                    var start_month = this.fdata.deduction_start_month; 
                    var loan_amount = this.toMoney(this.fdata.loan_amount);
                    if(loan_amount==0)
                    {
                        this.disable_submit_amount =true;
                        generate =0;
                    }
                    else
                    {
                        this.disable_submit_amount =false;
                        loan_amount = Math.round(loan_amount * 100) / 100;
                        generate =1;

                    }

                }
                else
                {
                    this.disable_submit_amount =true;
                    generate =0;
                }
                    
                if(generate==1)
                {
                    const str_month_arr = start_month.split("-");
                    var yr1   = parseInt(str_month_arr[1]);
                    var mt  = str_month_arr[0]; 
                    var mon1 = m_names.indexOf(mt);
                    var dt1   = 1; 
                    for (let i = 0; i < loan_tenure;i++) 
                    {
            
                        var d = new Date(yr1, mon1, dt1);
                        d.setMonth(d.getMonth() + i);
                        var fullText = m_names[d.getMonth()]+'-'+d.getFullYear();
                        all_months.push(fullText);
                        
                    }

                    if(all_months.length==loan_tenure)
                    {   
                        loan_amount = Math.round(loan_amount * 100) / 100;
                        var frac_month_amount = Math.floor(loan_amount/loan_tenure);
                        var round_amount = frac_month_amount*loan_tenure;
                        var extra_amount = loan_amount - round_amount;
                        for (let i = 0; i < loan_tenure;i++) 
                        {
                            if(i==0)
                            {
                                all_amounts.push(frac_month_amount+extra_amount);
                                continue;
                            }   
                            all_amounts.push(frac_month_amount);
                        } 

                        if(all_amounts.length==loan_tenure)
                        { 
                            var ct = 0;
                            for (let i = 0; i < loan_tenure;i++) 
                            { 
                                if(all_amounts[i]<=0)
                                {
                                    ct++;
                                    continue;
                                }

                                installments.push({month: all_months[i],amount:all_amounts[i]});
                                ct++;
                            }
                        }

                        if(loan_tenure==ct)
                        {
                            if(installments.length!=loan_tenure)
                            {
                                if(installments.length==0 && this.edit_form)
                                {
                                    this.fdata.remaining_tenure = 0;
                                }
                                else if(!this.edit_form)
                                {
                                    this.fdata.loan_tenure = installments.length;
                                }
                                else if(this.edit_form)
                                {
                                    this.fdata.remaining_tenure = installments.length;
                                }
                            }


                            if(installments.length>0)
                            {
                                for(let i = 0; i<installments.length; i++)
                                {
                                    installments[i].amount = this.formatMoney(installments[i].amount);
                                } 

                            }
                            this.loan_installments = installments;
                        }
                    }
                }

                console.log('gene');
                console.log(generate); 
            },
            onSubmit(e) 
            {   
                if(!this.checkNet()) return false;
                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    
                    e.preventDefault();  
                    let currentObj = this;
                    currentObj.errormsg = '';
                    this.showoverlaymodal = true;
                    let formData = new FormData();
                    this.fdata.installments = [];
                    /***** */
                    var pattern = /^(0|[1-9][0-9]{0,2}(?:(,[0-9]{3})*|[0-9]*))(\.[0-9]+){0,1}$/;
                    //if(pattern.test(this.fdata.loan_amount ))
                    if(1)
                    {
                        this.fdata.loan_amount =  this.toMoney(this.fdata.loan_amount);
                        this.fdata.loan_amount =  Math.round(this.fdata.loan_amount  * 100) / 100;
                    }
                    else
                    {
                        alert("Amount is invalid");
                        return 0;
                    }
                    
                    this.fdata.paid_amount =  this.toMoney(this.fdata.paid_amount);
                    this.fdata.paid_amount =  Math.round(this.fdata.paid_amount  * 100) / 100;
                    this.fdata.remaining_amount =  this.toMoney(this.fdata.remaining_amount);
                    this.fdata.remaining_amount =  Math.round(this.fdata.remaining_amount  * 100) / 100;
                    if(this.fdata.remaining_tenure == this.fdata.loan_tenure)
                    {
                        this.fdata.deduction_start_month = this.fdata.next_installment_month;
                    }
                    

                    if(this.loan_installments.length)
                    { 
                       
                        var installs = 0;
                        for(let i = 0; i<this.loan_installments.length; i++)
                        {
                            installs = this.toMoney(this.loan_installments[i].amount);
                            installs =  Math.round(installs  * 100) / 100;
                            this.loan_installments[i].amount = installs;
                        }
                        this.fdata.installments = JSON.stringify(this.loan_installments);
                        this.fdata.remaining_tenure = this.loan_installments.length;
                    }
                
                    /**** */
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                    } 

                     console.log(formData);

                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/loan/save', formData)
                        .then(function (response) 
                        {
                            
                            this.$bvToast.toast("Saved!", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            var data = this.fdata.employee_id;
                            this.$emit('childToParent'); 
                            //this.resetForm();
                            this.showoverlay = false;
                            this.showoverlaymodal = false;
                             
                        }.bind(this))
                        .catch(function (error) 
                        {           
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;                                    
                            for (var data in currentObj.errormsg)
                            {
                                var msg = currentObj.errormsg[data];
                                currentObj.$bvToast.toast(msg, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                }); 
                                currentObj.$validator.reset(); 
                            } 
                        });
                });
            },
            getLastPayrun: function(id)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/pf/get-last-payrun' , {
                    params: {
                       employee_id:id
                    }
                }).then(function(response){
                    console.log(response.data);
                    this.last_payrun_month = response.data;


                    var m_names = ['January', 'February', 'March', 
                                'April', 'May', 'June', 'July', 
                                'August', 'September', 'October', 'November', 'December'];

                    /** Get Last Payrun Date **/
                    var last_payrun_month_2 = this.last_payrun_month;
                    const str_month_arr_2 = last_payrun_month_2.split("-");
                    var payrun_year   = parseInt(str_month_arr_2[1]);
                    var p_month  = str_month_arr_2[0]; 
                    var payrun_month = m_names.indexOf(p_month);
                    var dt1   = 1;
                    const payrun_date = new Date(payrun_year,payrun_month,dt1);
                    payrun_date.setMonth(payrun_date.getMonth()+1);

                    this.date_min = payrun_date;


                    /****/
                }.bind(this));
            },
            
            getAvailablePf()
            {
                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
                formData.append('data_front', 'yes');  
                axios.post(this.$api_url+'/front/pf/employee/available-amount', formData) 
                    .then(function (response) 
                    {    
                        this.total_pf_balance = response.data;
                        this.getExisitingLoanBalance();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        console.log(error);
                    });
            },
            getExisitingLoanBalance()
            {
                let formData = new FormData();
                formData.append('employee_id', this.employee_id); 
                axios.post(this.$api_url+'/front/pf/employee-loan-balance', formData) 
                    .then(function (response) 
                    {    
                        this.existing_loan_balance = response.data.loan_availed - response.data.loan_returned;

                        this.pf_contribution = this.total_pf_balance - this.existing_loan_balance;

                    }.bind(this))
                    .catch(function (error) 
                    {
                        console.log(error);
                    });
            },
        },
    
        computed: 
        {
            onInstallmentChange()
            {
                if(this.loan_installments.length>0)
                { 
                    //console.log(this.loan_installments);
                    var installment_total = 0;
                    var install_money = 0;
                    var number = 0;
                    for(let i = 0; i< this.loan_installments.length; i++)
                    {
                        install_money = this.toMoney(this.loan_installments[i].amount);
                        number = Math.round(install_money * 100) / 100;
                        installment_total  = installment_total + number;
                        
                    }
                    installment_total = Math.round(installment_total * 100) / 100;
                    var payable_amount = 0;
                    if(this.edit_form)
                    {
                        if(this.disableamount == false)
                        {
                            
                            payable_amount = this.toMoney(this.fdata.loan_amount);
                            payable_amount = Math.round(payable_amount * 100) / 100;
                        }
                        else
                        {
                            payable_amount = this.toMoney(this.fdata.remaining_amount);
                            payable_amount = Math.round(payable_amount * 100) / 100;
                        }
                        
                    }
                    if (this.edit_form && this.is_custom_payment)
                    {
                        if(this.disableamount == false)
                        {
                        
                            payable_amount = this.toMoney(this.fdata.loan_amount) - this.toMoney(this.fdata.custom_amount)
                        }
                        else
                        {
                            payable_amount = this.toMoney(this.fdata.remaining_amount) - this.toMoney(this.fdata.custom_amount)
                        }
                    
                        payable_amount = this.toMoney(payable_amount);
                        payable_amount = Math.round(payable_amount * 100) / 100;
                    }
                    if(!this.edit_form)
                    {
                        payable_amount = this.toMoney(this.fdata.loan_amount);
                        payable_amount = Math.round(payable_amount * 100) / 100;
                    }
                    
                    if(installment_total!=payable_amount)
                    {
                        this.disable_submit = true;
                        this.remaining_installment_amount = payable_amount -installment_total;
                        if (isNaN(this.remaining_installment_amount)) {
                           this.remaining_installment_amount =' *Installment amount must be equal to total payable. Installment field contain invalid value';
                        }
                        else
                        {
                            if(this.remaining_installment_amount> 0)
                            {
                                this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' less than total payable';
                            }
                            if(this.remaining_installment_amount< 0)
                            {
                                this.remaining_installment_amount = this.remaining_installment_amount * (-1);
                                this.remaining_installment_amount  = this.formatMoney(this.remaining_installment_amount);
                                this.remaining_installment_amount =' *Installment amount must be equal to total payable. Total Installment amount is '+this.remaining_installment_amount+' more than total payable';
                            }
                        }
                    } 
                    else
                    {
                        this.disable_submit = false;
                        this.remaining_installment_amount =this.formatMoney(0);
                    }
                } 
            },
            checkInput()
            {
                if(this.disable_submit_new || this.disable_submit || this.disable_submit_amount || this.pf_loan_form_disable)
                {
                    this.disable_submit_all = true;
                }
                else
                {
                    this.disable_submit_all = false;
                }
                
            },
            checkPFLimit()
            {
                let loan_mon = this.toMoney(this.fdata.loan_amount);
                if(loan_mon > this.pf_contribution)
                {
                    this.pf_loan_form_disable =true;
                    if(this.edit_form==1 && this.fdata.status != 1)
                    {
                        this.pf_loan_form_disable =false;
                    }
                }
                else
                {
                    this.pf_loan_form_disable =false;
                }
            },

            checkInstallmentamount() 
            {
               
                if(this.is_custom)
                {

                    var ct_amount = this.toMoney(this.custom_amount);
                    ct_amount = Math.round(ct_amount * 100) / 100;
                    if(isNaN(ct_amount))
                    {
                        this.disable_submit_new = true;
                    }
                    else
                    {   

                    if(ct_amount==0)
                    {
                        this.disable_submit_new = true;
                    }
                    else
                    {
                        this.disable_submit_new = false;
                    }

                    }
                }
                else
                {
                    var ct_amount = 0.00; 
                }
                


                if(this.change_deduction_trigger=="1")
                {   
                    this.change_deduction = false;
                }
                else
                {
                    this.change_deduction = true;
                } 
                if(this.change_tenure_trigger=="1")
                {
                    this.change_tenure = false;
                }
                else
                {
                    this.change_tenure = true;
                }
                //console.log(this.fdata.loan_amount);


                if(this.fdata.loan_tenure > 0 && this.fdata.deduction_start_month != null && this.fdata.loan_amount != '' && this.fdata.effective_date_of_loan != '' && (ct_amount >= 0))
                {
                    
                    if(this.custom_amount === '')
                    {
                        this.fdata.custom_amount = 0;
                    }
                    else
                    {
                        this.fdata.custom_amount = ct_amount;

                    } 
                    this.getInstallments();
                    
                    this.showInstallment = true;
                    
                } 
                else 
                {
                    this.showInstallment = false; 
                    this.loan_installments = [];
                }

                
            },
        }, 
        created: function(){
            
            this.pf_contribution = 0;
            this.loan_installments = [];
            this.loan_type = 1;
            this.getAvailablePf();
            if(this.loan_id>0)
            {
                this.editLoanInfo(this.loan_id,this.is_custom);
                //alert("here is edit");
            }
            else
            {   
                 //alert("here is add");
                this.getLastPayrun(this.employee_id);
                this.addNewLoan(1);
           }  
           if(this.is_front==1)
            {
                this.employee_front = true;
            }
            else
            {
                this.employee_front = false;
            }

        } 
    }
</script>
